import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useParams } from 'react-router-dom';

import FrequencyType from './frequencyType';
import DurationType from './durationType';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { getBehaviors } from '../../../../../redux/State/clientSlice/behaviorReductionSlice';
import { RecordingType } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';

const Behaviours = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const behaviors = useSelector((state) => state.behaviorReduction.behaviors);

	useEffect(() => {
		if (!clientId) return;
		dispatch(getBehaviors({ clientId, includeArchived: false }))
			.then(unwrapResult)
			.catch(errorNormalizer);
	}, [clientId, dispatch]);

	return (
		<div className="behaviorWrapper">
			{behaviors.map((x) => (
				<div key={x.id} className="behavior">
					{RecordingType.frequency === x.recordingType.id && <FrequencyType behavior={x} />}
					{RecordingType.duration === x.recordingType.id && <DurationType behavior={x} />}
				</div>
			))}
		</div>
	);
};

export default Behaviours;
